import { useGlobalContext } from '~/context/GlobalContext';
import { IChatRoom, IUser } from '~/types/common';
import classNames from 'classnames';
import Notification from '~/components/PrivateChatContainer/Notification';
import { openAvatarLightbox } from '~/components/AvatarLightbox/openAvatarLightbox';
import styles from './Avatar.module.css';

interface IAvatarProps {
  user: IUser | null;
  room: IChatRoom | null;
  isShow: boolean
}

function Avatar({ user, room }: IAvatarProps) {
  const { context } = useGlobalContext();

  if (!user || !room) return null;

  const isRoomActive = room.id === context.room?.id && context.activeSidebarId === '';
  const isMale = user.gender === 'male';
  const avatarUrl = user.avatar || null;

  const handleAvatarClick = (e: React.MouseEvent) => {
    if (!avatarUrl) return; // gość/anon — bez galerii w czacie prywatnym
    e.preventDefault();
    e.stopPropagation();
    openAvatarLightbox({ userName: user.name, avatarUrl });
  };

  return (
    <button
      data-component="Avatar"
      data-id={user.id}
      onClick={handleAvatarClick}
      title={avatarUrl ? 'Pokaż zdjęcia' : ''}
      className={classNames(styles.avatar, {
        [styles.active]: isRoomActive,
      })}>
      {avatarUrl ? (
        <img className={styles.photo} src={avatarUrl} alt={user.name} />
      ) : (
        <img className={styles.image} src={`/img/common/${isMale ? 'male-white' : 'female-white'}.svg`} alt="avatar" />
      )}
      <Notification
        roomId={room.id}
        count={room.unreadCount}
        className={styles.notification}
      />
    </button>
  );
}

export default Avatar;
